import { render, staticRenderFns } from "./EditorItem.vue?vue&type=template&id=3703a50b&scoped=true"
import script from "./EditorItem.vue?vue&type=script&lang=js"
export * from "./EditorItem.vue?vue&type=script&lang=js"
import style0 from "./EditorItem.vue?vue&type=style&index=0&id=3703a50b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703a50b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3703a50b')) {
      api.createRecord('3703a50b', component.options)
    } else {
      api.reload('3703a50b', component.options)
    }
    module.hot.accept("./EditorItem.vue?vue&type=template&id=3703a50b&scoped=true", function () {
      api.rerender('3703a50b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/EditorItem.vue"
export default component.exports